import React from 'react'
import { useTranslation } from 'react-i18next'
import { useProfileUpdatePasswordMutation } from '@/features/profile/store'
import { useNotify } from '@/hooks'
import { PasswordForm } from './PasswordForm'

export const PasswordUpdate = () => {
  const { t } = useTranslation()

  const { showNotification } = useNotify()

  const [updatePassword] = useProfileUpdatePasswordMutation()

  const onSubmit = async (values: any) => {
    await updatePassword(values).unwrap()

    showNotification({
      type: 'success',
      message: t('password_changed_successfully'),
    })
  }

  return (
    <>
      <PasswordForm onSubmit={onSubmit} />
    </>
  )
}
